export const footerLiftVar = '--footer-lift';
export const intercomOpenAttr = 'data-intercom-open';
